import { c as _c } from "react/compiler-runtime";
import { Footer } from "@website/widget/footer";
import { Header, HeaderPropertiesType } from "@website/widget/header";
import { ReactNode } from "react";
interface Properties {
  children: ReactNode;
  headerProps?: HeaderPropertiesType;
}
export const TourLayout = t0 => {
  const $ = _c(8);
  const {
    children,
    headerProps
  } = t0;
  let t1;
  if ($[0] !== headerProps) {
    t1 = <Header title={"\u062A\u0648\u0631"} {...headerProps} />;
    $[0] = headerProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <main className="bg-dim-background flex-1">{children}</main>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Footer />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2) {
    t4 = <div className="flex min-h-screen flex-col">{t1}{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};